<template>
	<div id="hourly-consumption-chart" style="height: 500px"></div>
</template>
<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
/**
 * this.data is an array of objects like this:
{
	"day": 3,
	"hour": 7,
	"supply": 36,
	"selfProduction": 6,
	"supplySampleCount": 8,
	"selfProductionSampleCount": 34
}
 */
export default {
	name: "HourlyConsumption",
	props: ['data'],
	data() {
		return {
			colors: this.$store.state.colors,
			supply: [],
			selfProduction: [],
		}
	},
	mounted() {
		var chart = am4core.create("hourly-consumption-chart", am4charts.XYChart);
		var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
		categoryAxis.dataFields.category = "dayHour";

		// set a custom format for the category axis
		categoryAxis.renderer.labels.template.adapter.add("text", (text, target, key) => {
			if (target.dataItem.category) {
				let labelValue = target.dataItem.category.split("-");

				// get the name of the day from labelValue[0]
				const dayName = this.daysNames[parseInt(labelValue[0]) - 1];

				// convert hour to 24-hour format
				const hour = parseInt(labelValue[1]);
				//pad the hour with a leading zero if it's less than 10
				const hour24 = hour < 10 ? "0" + hour : hour;

				return `${dayName}\n${hour24}:00`;
			}
			return text;
		});

		chart.data = this.data.map(item => {
			return {
				dayHour: `${item.day}-${item.hour}`,
				supply: item.supply,
				selfProduction: item.selfProduction
			}
		})

		var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
		valueAxis.name = "[kWh]";
		valueAxis.title.text = "[kWh]";

		var series = chart.series.push(new am4charts.LineSeries());
		series.dataFields.valueY = "supply";
		series.dataFields.categoryX = "dayHour";
		series.name = "Prelievo";
		series.stacked = true;
		series.fillOpacity = 0.85;
		series.stroke = am4core.color(this.colors[0]);
		series.fill = am4core.color(this.colors[0]);

		var series2 = chart.series.push(new am4charts.LineSeries());
		series2.dataFields.valueY = "selfProduction";
		series2.dataFields.categoryX = "dayHour";
		series2.name = "Autoproduzione";
		series2.stacked = true;
		series2.fillOpacity = 0.85;
		series2.stroke = am4core.color(this.colors[1]);
		series2.fill = am4core.color(this.colors[1]);


		chart.legend = new am4charts.Legend();

	},
	methods: {
	},
	computed: {
		daysNames() {
			return this.$store.state.utils.daysShort
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/BillAudit/Charts/HourlyConsumption.vue